import  React ,{useState} from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import { Email, Phone } from '@mui/icons-material';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import grclogo from '../../Images/GRC-Pulse-Logo.png';
import ListIcon from '@mui/icons-material/List';
import { COLORS } from '../colors';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { SlCalender } from 'react-icons/sl';
import { IoNotificationsOutline } from "react-icons/io5";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { MdOutlineHolidayVillage } from "react-icons/md";

const pages = ['Admin Dashboard', 'Master Data', 'Monthly Data', 'Create'];
const settings = ['Corporate List', 'Establishment List', 'Assessor List'];

export default function AdminAppBar() {
  const [anchorEl, setAnchorEl] = useState(null);
    const [masterAnchorEl, setMasterAnchorEl] = useState(null);
    const [monthlyAnchorEl, setMonthlyAnchorEl] = useState(null);
  const [elibraryAnchorEl, setElibraryAnchorEl] = useState(null);

  const [anchorElCreate, setAnchorElCreate] = useState(null);
  const [showListText, setShowListText] = useState(false);
  const [showLogoutText, setShowLogoutText] = useState(false);
  const [showCalenderText, setShowCalenderText] = useState(false)
  const navigate = useNavigate();
  const location = useLocation();
  const [showNotificationText, setShowNotificationText] = useState(false);
  const [showHolidayList, setShowHolidayList] = useState(false);
 const [menuLabels, setMenuLabels] = useState({
  monthly: "Monthly Data",
  create: "Create",
  master : "Master Data",
  elibrary: 'Elibrary'
 
});
  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

    
   
   const handleMenuClick = (key, label, path) => {
  setMenuLabels((prev) => ({ ...prev, [key]: label }));
  navigate(path);

};

const handleMenuClose = (menu) => {
  if (menu === "create") setAnchorElCreate(null);
   if (menu === "master") setMasterAnchorEl(null);
  if (menu === "monthly") setMonthlyAnchorEl(null);
 if (menu === "elibrary") setElibraryAnchorEl(null);
};

   const handleMasterMenuOpen = (event) => {
  setMasterAnchorEl(event.currentTarget);
};






 const handleMonthlyMenuOpen = (event) => {
  setMonthlyAnchorEl(event.currentTarget);
};




  const handleOpenCreateMenu = (event) => {
    setAnchorElCreate(event.currentTarget);
  };
  
const handleElibraryMenuOpen = (event) => {
  setElibraryAnchorEl(event.currentTarget);  // store button DOM element
};

  
  const handleListOfClients = () => {
    navigate("/establishmentsList");
    setAnchorEl(null);
  }

  const handleListOfAssessors = () => {
    navigate("/assessorList");
    setAnchorEl(null);

  }
  const handleListOfCorporate = () => {
    navigate("/corporateList");
    setAnchorEl(null);

  }

 
  const handleLogout = () => {
    navigate("/signin");
    sessionStorage.clear();
  };
  

     const isPageActive = (path) => location.pathname === path;

  return (
    <AppBar position="sticky" sx={{ backgroundColor: '#1C1C1C	' }}>
      <Container maxWidth="xxl">
        <Toolbar disableGutters>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <Typography
              variant="h6"
              noWrap
              component="a"
              href="/admindashboard"
              sx={{
                mr: 2,
                display: { xs: 'flex', md: 'flex' },
                fontFamily: 'monospace',
                fontWeight: 700,
                letterSpacing: '.3rem',
                textDecoration: 'none',
              }}
            >
              <img
                src={grclogo}
                width="130px"
                alt="Company Logo"
                style={{
                  padding: '5px'
                }}
              />
            </Typography>

            <Box sx={{ display: 'flex', alignItems: 'center', fontSize: 12, color: COLORS.ivory }}>
              <Typography sx={{ mr: 1 }}>
                <a href="mailto:support@grcpulse.in" style={{ textDecoration: 'none', color: COLORS.ivory }}>
                  <Email /> support@grcpulse.in
                </a>
              </Typography>
              <Typography><Phone /> 080-31634351 <br /> <span style={{ paddingLeft: '20px' }}>+91-8310163968 </span></Typography>
            </Box>
          </Box>
        </Toolbar>
        <Box sx={{ backgroundColor: '#B22222' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
            <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "flex" } }}>
              {pages.map((page) => (
                page === "Create" ? (
                  <Box
                    key={page}
                    sx={{
                      m: 1,
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      textTransform: 'none',
                      cursor: 'pointer',
                      width: 'auto',
                    }}
                    onClick={handleOpenCreateMenu}

                  >

                    <Typography sx={{ fontSize: 15, 
                      color:
                   isPageActive("/createCorporate") ||
      isPageActive("/createCompany") || 
      isPageActive("/createAssessor")
        ? "white"
        : "#C0C0C0",
          }}>
                      
                      {menuLabels.create}</Typography>
                    <Button
                      sx={{
                        minWidth: 'auto',
                        padding: 0,
                        color: '#C0C0C0',
                      }}

                    >
                      <ArrowDropDownIcon onClick={handleOpenCreateMenu} />
                    </Button>
                  </Box>
                ) : page==='Master Data' ? (
                   <div key={page}>
                          
                                   <Box
                                                key={page}
                                                sx={{
                                                  m: 2,
                                                  display: 'flex',
                                                  justifyContent: 'space-between',
                                                  alignItems: 'center',
                                                  textTransform: 'none',
                                                  cursor: 'pointer',
                                                  width: 'auto',
                                                }}
                                                onClick={handleMasterMenuOpen}
                            
                                              >
                            <Typography sx={{ fontSize: 15, 
                               color:
                   isPageActive("/vendorsmasterdata") ||
      isPageActive("/establishmentmasterdata")
        ? "white"
        : "#C0C0C0",
          }}>
                              {menuLabels.master}
                            </Typography>
                             <Button
                                                  sx={{
                                                    minWidth: 'auto',
                                                    padding: 0,
                                                    color: '#C0C0C0',
                                                  }}
                            
                                                >
                                                  <ArrowDropDownIcon  onClick={handleMasterMenuOpen} />
                                                </Button>
                          </Box>
                  
                          <Menu
                            anchorEl={masterAnchorEl}
                            open={Boolean(masterAnchorEl)}
                          >
                            <MenuItem onClick={() => {
                              handleMenuClick('master','Vendors Master Data','/vendorsmasterdata')
                              handleMenuClose('master')
                            }}>
                              
                              Vendors Master Data
                            </MenuItem>
                            <MenuItem onClick={() => {
                               handleMenuClick('master','Establishment Master Data','/establishmentmasterdata')
                              handleMenuClose('master')
                            }}>
                               Establishment Master Data
                            </MenuItem>
                          </Menu>
                        </div>
                )
                : page==='Monthly Data' ? (
                   <div key={page}>
                          
                                   <Box
                                                key={page}
                                                sx={{
                                                  m: 2,
                                                  display: 'flex',
                                                  justifyContent: 'space-between',
                                                  alignItems: 'center',
                                                  textTransform: 'none',
                                                  cursor: 'pointer',
                                                  width: 'auto',
                                                }}
                                                onClick={handleMonthlyMenuOpen}
                            
                                              >
                            <Typography sx={{ fontSize: 15, 
color:isPageActive("/vendorsmonthlydata") ||
      isPageActive("/establishmentmonthlydata")
        ? "white"
        : "#C0C0C0"}}>
                              {menuLabels.monthly}
                            </Typography>
                             <Button
                                                  sx={{
                                                    minWidth: 'auto',
                                                    padding: 0,
                                                    color: '#C0C0C0',
                                                  }}
                            
                                                >
                                                  <ArrowDropDownIcon  onClick={handleMonthlyMenuOpen} />
                                                </Button>
                          </Box>
                  
                          <Menu
                            anchorEl={monthlyAnchorEl}
                            open={Boolean(monthlyAnchorEl)}
                          >
                            <MenuItem 
 onClick={() => {
                                handleMenuClick('monthly',' Vendors Monthly Data','/vendorsmonthlydata')
                               handleMenuClose('monthly')
                              }
                              }>
                              Vendors Monthly Data
                            </MenuItem>
                            <MenuItem 
                          onClick={() => {
                                 handleMenuClick('monthly',' Establishment Monthly Data','/establishmentmonthlydata')
                                   handleMenuClose('monthly')
                              }
                                 }>
                              Establishment Monthly Data
                            </MenuItem>
                          </Menu>
                        </div>
                ): (
                  <Button
                    key={page}
                    sx={{
                      m: 1,
                      display: 'block',
                      textTransform: 'none',
                    }}
                  >
                    <Link className="nav-link" to={`/${page.replace(/\s+/g, '').toLowerCase()}`} style={{ color: COLORS.ivory, textDecoration: 'none' }}>
                      <Typography sx={{ fontSize: 15, color: isPageActive(page) ? 'white' : '#C0C0C0' }}>{page}</Typography>
                    </Link>
                  </Button>
                )
              ))}
            </Box>
  <Box
                            
                              sx={{
                                m: 2,
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                textTransform: 'none',
                                cursor: 'pointer',
                                width: 'auto',
                              }}
                        
          
                            >
             
                 <Typography sx={{ fontSize: 15, color:
                   isPageActive("/minimum-wages-management") ||
      isPageActive("/industry-type-management") ||
      isPageActive("/holidayList") 
        ? "white"
        : "#C0C0C0",
          }}>
            {menuLabels.elibrary}
          </Typography>
           <Button
                                sx={{
                                  minWidth: 'auto',
                                  padding: 0,
                                  color: '#C0C0C0',
                                }}
          
                              >
                                <ArrowDropDownIcon   onClick={handleElibraryMenuOpen} />
                              </Button>
            
              <Menu
              anchorEl={elibraryAnchorEl}
  open={Boolean(elibraryAnchorEl)}
  
              >
                   <MenuItem  onClick={() => {
                                handleMenuClick('elibrary','Minimum Wages','/minimum-wages-management');
                               handleMenuClose('elibrary')
                              }
                              }>
                    
                  Minimum Wages
                  </MenuItem>
               
               <MenuItem  onClick={() => {
                                handleMenuClick('elibrary','Industry Types','/industry-type-management');
                               handleMenuClose('elibrary')
                              }
                              }>
                    
                  Industry Types
                  </MenuItem>

               <MenuItem  onClick={() => {
                                handleMenuClick('elibrary','Holiday List','/holidayList');
                               handleMenuClose('elibrary')
                              }
                              }>
                    
                  Holiday List
                  </MenuItem>

                  <MenuItem  onClick={() => {
                                handleMenuClick('elibrary','Acts/Rules','/acts');
                               handleMenuClose('elibrary')
                              }
                              }>
                    
                  Acts/Rules
                  </MenuItem>

                  
              </Menu>
               </Box>
             
           
            <Box sx={{ display: 'flex',alignItems:'center'}}>
               <Tooltip title={showNotificationText ? 'Add Notification' : ''}>
                <Link to="/updates">
                  <IoNotificationsOutline
                    onMouseEnter={() => setShowNotificationText(true)}
                    onMouseLeave={() => setShowNotificationText(false)}
                    className='text-white text-3xl cursor-pointer' />
                </Link>
              </Tooltip>
              <Tooltip className='mx-2' title={showCalenderText ? 'Compliance Calendar' : ''}>
                <Link to="/complience-calender">
                  <SlCalender
                    onMouseEnter={() => setShowCalenderText(true)}
                    onMouseLeave={() => setShowCalenderText(false)}
                    size="1.6rem" color='#ffffff' />
                </Link>
              </Tooltip>
              <Tooltip title={showListText ? 'List' : ''}>
                <IconButton
                  onClick={handleOpenMenu}
                  onMouseEnter={() => setShowListText(true)}
                  onMouseLeave={() => setShowListText(false)}
                  sx={{ p: 1 }}
                >
                  <ListIcon sx={{ fontSize: '35px', color: COLORS.ivory }} />
                </IconButton>
              </Tooltip>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleCloseMenu}
              >
                {settings.map((setting) => (
                  <MenuItem
                    key={setting}
                    onClick={() => {
                      if (setting === 'Establishment List') {
                        handleListOfClients();
                      } else if (setting === 'Assessor List') {
                        handleListOfAssessors();
                      }
                      else if (setting === 'Corporate List') {
                        handleListOfCorporate();
                      }
                    }}
                  >
                    <Typography textAlign="center">{setting}</Typography>
                  </MenuItem>
                ))}
              </Menu>
              <Menu
                anchorEl={anchorElCreate}
                open={Boolean(anchorElCreate)}
              >
                <MenuItem 
                onClick={() => {
                                handleMenuClick('create',' Create Corporate','/createCorporate')
                               handleMenuClose('create')
                              }
                              }>
                
                  Create Corporate
                </MenuItem>
                <MenuItem 
                  onClick={() => {
                                handleMenuClick('create','Create Establishment','/createCompany')
                               handleMenuClose('create')
                              }
                              }>
                                Create Establishment
                 
                </MenuItem>
                <MenuItem 
   onClick={() => {
                                handleMenuClick('create','Create Assessor','/createAssessor')
                               handleMenuClose('create')
                              }
                              }>
                                Create Assessor
                </MenuItem>
              </Menu>
              <Tooltip title={showLogoutText ? 'Log Out' : ''}>
                <IconButton
                  onClick={handleLogout}
                  onMouseEnter={() => setShowLogoutText(true)}
                  onMouseLeave={() => setShowLogoutText(false)}
                  sx={{ p: 1 }}
                >
                  <LogoutIcon sx={{ fontSize: '30px', color: COLORS.ivory }} />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
        </Box>
      </Container>
    </AppBar>

  );
}
